module.exports = __webpack_public_path__ + "img/santarosa_hero_card.bd762031.png";